const actions = {
    setPulseLoader({
        dispatch
    }, val) {
        dispatch('common/setPulseLoader', val)
    },
    setLoginVisible({
        dispatch
    }, val) {
        dispatch('common/setLoginVisible', val, {
            root: true
        })
    },
    setQuestionTypeList({
        dispatch
    }) {
        dispatch('common/setQuestionTypeList', null, {
            root: true
        })
    },
    setCurrentExpInfo({
        dispatch
    }, curExp) {
        dispatch('common/setCurrentExpInfo', curExp, {
            root: true
        })
    },
    setRefresh({
        dispatch
    }, update) {
        dispatch('common/setRefresh', update, {
            root: true
        })
    },
    setToken({
        dispatch
    }, token) {
        dispatch('user/setToken', token, {
            root: true
        })
    },
    setUserinfo({
        dispatch
    }, userInfo) {
        dispatch('user/setUserinfo', userInfo, {
            root: true
        })
    },
    LogOut({
        dispatch
    }) {
        dispatch('user/LogOut', {
            root: true
        })
    },
    shenbaoLogOut({
        dispatch
    },key) {
        dispatch('user/shenbaoLogOut', key, {
            root: true
        })
    },
    FedLogOut({
        dispatch
    }) {
        dispatch('user/FedLogOut', {
            root: true
        })
    },
    Fed404LogOut({
        dispatch
    }) {
        dispatch('user/Fed404LogOut', {
            root: true
        })
    },
    LoginByUsername({
        dispatch
    }, userInfo) {
        return dispatch('user/LoginByUsername', userInfo, {
            root: true
        })
    },
    LoginByShenbao({
        dispatch
    }, userInfo) {
        return dispatch('user/LoginByShenbao', userInfo, {
            root: true
        })
    },
    GetUserInfo({
        dispatch
    }) {
        return dispatch('user/GetUserInfo', null, {
            root: true
        })
    },
}

export default actions